// import { Fragment, useState } from "react";
// import styled from "styled-components/macro";
// import { useNavigate } from "react-router-dom";
// import { FaRegUser } from "react-icons/fa";
// import { IoInformationCircleOutline } from "react-icons/io5";
// import { Grid, IconButton, Tooltip, Typography } from "@mui/material";

// import { Paper } from "../../../components";
// import pages from "../../../constants/pages";
// import {
//   HeadingEighteen,
//   TextFourteenBlack,
//   TextFifteenYellow,
//   colors,
// } from "../../css components/Style";
// import LOGO from "../../../assets/default_logo.webp";
// import {
//   brandDetailsObject,
//   objectFromResponse,
// } from "../../brand components/brand details components/brandDetailObject";
// import BrandDetailsDialog from "../../campaign components/brand details components/BrandDetailsDialog";

// let siteColors = JSON.parse(sessionStorage.getItem("siteColors"));

// const Link = styled(Typography)`
//   font-weight: 400;
//   font-size: 18px;
//   line-height: 27px;
//   color: ${siteColors?.primary};
//   cursor: pointer;
// `;

// const ImageDiv = styled.div`
//   height: 55.8px;
//   width: 55.8px;
//   margin-left: 15px;
// `;

// const Image = styled.img`
//   height: 100%;
//   width: 100%;
//   border-radius: 50%;
// `;

// const Icon = styled(IconButton)`
//   border: 1px solid ${siteColors?.primary};
//   color: ${siteColors?.primary};
//   height: 35px;
//   width: 35px;
//   margin: 0 5px;
//   padding: 0 5px;
//   &:hover {
//     border: 1px solid ${siteColors?.primary};
//     box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
//   }
// `;

// function convertDate(d) {
//   let date = new Date(d);

//   return (
//     date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear()
//   );
// }

// export default function BrandList({ brandList, component }) {
//   const navigate = useNavigate();
//   const [brandDetails, setBrandDetails] = useState({
//     data: brandDetailsObject,
//     state: false,
//   });

//   const onImageError = (e) => {
//     e.target.src = LOGO;
//   };

//   function handleNavigation(brand) {
//     if (component === "users") {
//       navigate(pages.usersList.route + brand.brand_id);
//     }

//     if (component === "campaign") {
//       navigate(pages.superAdminBrandCampaigns.route + brand.brand_id);
//     }
//   }

//   return (
//     <Fragment>
//       <Grid container spacing={3}>
//         {brandList.map((brand) => (
//           <Grid item xs={12} key={brand.brand_id}>
//             <Paper style={{ padding: "0px" }} noGrid={true}>
//               <Grid container spacing={0}>
//                 <Grid item alignSelf="center" paddingRight="15px">
//                   <ImageDiv>
//                     <Image
//                       src={brand.logo ? brand.logo : LOGO}
//                       alt="!"
//                       onError={onImageError}
//                     />
//                   </ImageDiv>
//                 </Grid>

//                 <Grid item xs style={{ padding: "10px 25px" }}>
//                   <Grid container>
//                     <Grid item xs={12} justifyContent={"end"} display="flex">
//                       {brand.new_user && (
//                         <Fragment>
//                           <svg
//                             style={{
//                               position: "relative",
//                               margin: "9px 9px",
//                             }}
//                             width="10"
//                             height="10"
//                             viewBox="0 0 10 10"
//                             fill="none"
//                             xmlns="http://www.w3.org/2000/svg"
//                           >
//                             <circle cx="5" cy="5" r="5" fill={"#FFBB0B"} />
//                           </svg>
//                           <TextFifteenYellow
//                             style={{ fontSize: "14px" }}
//                             color={colors.warning}
//                           >
//                             New Users Pending Approval
//                           </TextFifteenYellow>
//                         </Fragment>
//                       )}
//                     </Grid>

//                     <Grid item xs={2.5}>
//                       <div style={{ display: "flex" }}>
//                         <TextFourteenBlack> Brand </TextFourteenBlack>

//                         <IoInformationCircleOutline
//                           onClick={() => handleBrandDetails(brand)}
//                           style={{
//                             color: siteColors?.primary,
//                             marginLeft: "5px",
//                             fontSize: "25px",
//                             cursor: "pointer",
//                             position: "relative",
//                             bottom: "4px",
//                           }}
//                         />
//                       </div>

//                       <HeadingEighteen>{brand.brand_name}</HeadingEighteen>
//                     </Grid>

//                     <Grid item xs={3}>
//                       <TextFourteenBlack>Partner Type</TextFourteenBlack>
//                       <HeadingEighteen>
//                         {brand.business_entity_type_name}
//                       </HeadingEighteen>
//                     </Grid>

//                     <Grid item xs={1.5}>
//                       <TextFourteenBlack>Date Joined</TextFourteenBlack>
//                       <HeadingEighteen>
//                         {convertDate(brand.created_date)}
//                       </HeadingEighteen>
//                     </Grid>

//                     <Grid item xs={1.5}>
//                       <TextFourteenBlack>Total Users</TextFourteenBlack>
//                       <HeadingEighteen>{brand.total_users}</HeadingEighteen>
//                     </Grid>

//                     <Grid
//                       item
//                       xs={2}
//                       alignSelf={"center"}
//                       display="flex"
//                       justifyContent="end"
//                     >
//                       <Link onClick={() => handleNavigation(brand)}>
//                         {component === "campaign" ? (
//                           "Campaigns"
//                         ) : (
//                           <Tooltip title="View Users">
//                             <Icon>
//                               <FaRegUser
//                                 style={{ height: "20px", width: "20px" }}
//                               />
//                             </Icon>
//                           </Tooltip>
//                         )}
//                       </Link>
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//         ))}
//       </Grid>

//       {brandList.length === 0 && (
//         <Grid item container p={12} justifyContent={"center"} xs={12}>
//           <Typography variant="h3">No Brand Found</Typography>
//         </Grid>
//       )}
//       <BrandDetailsDialog details={brandDetails} setDetails={setBrandDetails} />
//     </Fragment>
//   );

//   function handleBrandDetails(brandData) {
//     setBrandDetails({
//       data: objectFromResponse(brandData),
//       state: true,
//       component: "connection",
//     });
//   }
// }

import * as React from "react";
import { Fragment } from "react";
import { styled } from "@mui/material/styles";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Avatar,
  Typography,
} from "@mui/material";
import { FaRegUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { tableCellClasses } from "@mui/material/TableCell";

import { Chip } from "../../../components";
import pages from "../../../constants/pages";
import { colors } from "../../css components/Style";
import {
  brandDetailsObject,
  objectFromResponse,
} from "../../brand components/brand details components/brandDetailObject";
import BrandDetailsDialog from "../../campaign components/brand details components/BrandDetailsDialog";

const Icon = styled(IconButton)`
  border: 1px solid ${colors?.sideBarColor};
  color: ${colors?.sideBarColor};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors?.sideBarColor};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const Link = styled(Typography)`
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  color: ${colors?.sideBarColor};
  cursor: pointer;
`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.iconColor,
    color: "#fff",
    fontSize: "11px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    backgroundColor: "#F9F9F9",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  ".MuiTableCell-root": {
    border: "none",
    padding: "10px",
    fontSize: "12px",
  },

  "&:nth-of-type(2n+1)": {
    backgroundColor: "rgba(249, 249, 249, 1)",
  },

  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function List({ brandList, component }) {
  const navigate = useNavigate();

  const [brandDetails, setBrandDetails] = React.useState({
    data: brandDetailsObject,
    state: false,
  });

  function convertDate(d) {
    let date = new Date(d);

    return (
      date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear()
    );
  }

  function handleNavigation(brand) {
    if (component === "users") {
      navigate(pages.usersList.route + brand.brand_id);
    }

    if (component === "campaign") {
      navigate(pages.superAdminBrandCampaigns.route + brand.brand_id);
    }
  }

  function handleBrandDetails(brandData) {
    setBrandDetails({
      data: objectFromResponse(brandData),
      state: true,
      component: "connection",
    });
  }

  return (
    <Fragment>
      <TableContainer
        sx={{ maxHeight: "90%", borderRadius: "10px" }}
        component={Paper}
      >
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead style={{ height: "65px" }}>
            <TableRow>
              <StyledTableCell />

              <StyledTableCell>Brand Name</StyledTableCell>
              <StyledTableCell>Date Joined</StyledTableCell>
              <StyledTableCell>Partner Type</StyledTableCell>
              <StyledTableCell>Total Users</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {brandList.map((brand) => (
              <StyledTableRow>
                <Fragment>
                  <StyledTableCell component="th" scope="row">
                    <Avatar
                      onClick={() => handleBrandDetails(brand)}
                      src={brand.logo}
                      style={{
                        height: "40px",
                        width: "40px",
                        cursor: "pointer",
                      }}
                    />
                  </StyledTableCell>

                  <StyledTableCell component="th" scope="row">
                    {brand.brand_name.replace(/_/g, " ") || "-"}
                  </StyledTableCell>

                  <StyledTableCell component="th" scope="row">
                    {convertDate(brand.created_date)}
                  </StyledTableCell>

                  <StyledTableCell component="th" scope="row">
                    <PartnerChip brand={brand} />
                  </StyledTableCell>

                  <StyledTableCell component="th" scope="row">
                    {brand.total_users}
                  </StyledTableCell>

                  <StyledTableCell component="th" scope="row">
                    <Link onClick={() => handleNavigation(brand)}>
                      {component === "campaign" ? (
                        "Campaigns"
                      ) : (
                        <Tooltip title="View Users">
                          <Icon>
                            <FaRegUser
                              style={{ height: "20px", width: "20px" }}
                            />
                          </Icon>
                        </Tooltip>
                      )}
                    </Link>
                  </StyledTableCell>
                </Fragment>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <BrandDetailsDialog details={brandDetails} setDetails={setBrandDetails} />
    </Fragment>
  );

  function PartnerChip({ brand }) {
    let color;
    let label;
    if (brand.business_entity_type_name === "MONETIZATION_PARTNER") {
      color = colors.sideBarColor;
      label = brand.business_entity_type_name.substring(
        0,
        brand.business_entity_type_name.indexOf("_")
      );
    }

    if (brand.business_entity_type_name === "BOTH") {
      color = colors.yellow;
      label = "BOTH";
    }

    if (brand.business_entity_type_name === "PROMOTION_PARTNER") {
      color = colors.lightGreen;
      label = brand.business_entity_type_name.substring(
        0,
        brand.business_entity_type_name.indexOf("_")
      );
    }

    return <Chip label={label} background={color} />;
  }
}
